import PropTypes from 'prop-types';
import Dialog from 'material-ui/Dialog';
import intl from 'react-intl-universal';
import StyledOrderDetailsModal from './styled';
import { Link } from 'react-router-dom'
import Button from 'components/button';

const OrderDetailsModal = ({ isOpen, onClose, orderDetails }) => {
  return (
      <Dialog
        title={intl.get('commons.orderDetails') || 'Detalhes do Pedido'}
        open={isOpen}
        contentStyle={{ width: '500px', maxWidth: '90%' }}
        onRequestClose={onClose}
        actions={[
          <Button
            key={`btn-${intl.get('geral.buttonsDefault.close') || 'Fechar'}`}
            value={intl.get('geral.buttonsDefault.close') || 'Fechar'}
            onClick={onClose}
            data-testid="close-button"
          />
        ]}
        autoScrollBodyContent
      >
        <StyledOrderDetailsModal>
          <div className="order-list">
            {orderDetails.map((detail) => (
              <div 
                key={`${detail.OrderId}-${detail.OrderItemNumber}`}
                className="order-item"
              >
                <Link 
                  to={`/stocksDetail/${detail.LabeledFamilyCenterId}/${detail.OrderId}/P`}
                  target="_blank"
                  rel="noopener noreferrer"
                  className="order-link"
                >
                  {detail.OrderId}
                </Link>
                {` - ${detail.OrderNumber}-${detail.OrderItemNumber}`}
              </div>
            ))}
          </div>
        </StyledOrderDetailsModal>
      </Dialog>
    );
}

OrderDetailsModal.propTypes = {
  isOpen: PropTypes.bool.isRequired,
  onClose: PropTypes.func.isRequired,
  orderDetails: PropTypes.array.isRequired
};

export default OrderDetailsModal;
